module.exports = __webpack_public_path__ + "img/logo_chumphonlab.2c60a41b.jpg";